import { AddButton, CancelButton, FinishButton, PrimaryButton } from "components/Common/CustomButtons/CustomButtons";
import { EDIT_TRADE_DETAILS_LABELS } from "constants/auditTrail";
import { ACTION_BUTTONS_NAME } from "constants/generalActionButtons";
import { setDataToLocalStorage } from "helpers/generalHelper";

export const EditTradeFooter = (
  props,
  triggerPostEditApi,
  isRequestActive,
  isCreateLoading,
  isSaveAndCreateButtonDisabled,
  onAddTrader,
  onAddCompany
) => [
  <CancelButton
    key={ACTION_BUTTONS_NAME.EDIT_TRADE_DETAILS.key}
    onClick={() => {
       setDataToLocalStorage("initialTrade", {});
       props.handleMenuItemClicked(false);
    }}
  >
    {EDIT_TRADE_DETAILS_LABELS.CANCEL}
  </CancelButton>,
  <PrimaryButton
    loading={isCreateLoading}
    disabled={isSaveAndCreateButtonDisabled || isRequestActive}
    key={EDIT_TRADE_DETAILS_LABELS.SAVE_SEND_AND_COPY}
    onClick={triggerPostEditApi}
  >
    {EDIT_TRADE_DETAILS_LABELS.SAVE_SEND_AND_COPY}
  </PrimaryButton>,
 
  <AddButton
    key={EDIT_TRADE_DETAILS_LABELS.ADD_TRADER}
    onClick={() => {
      onAddTrader();
    }}
  >
    {EDIT_TRADE_DETAILS_LABELS.ADD_TRADER}
  </AddButton>,
  <FinishButton
    key={EDIT_TRADE_DETAILS_LABELS.FINISH}
    onClick={() => {
       setDataToLocalStorage("initialTrade", {});
      props.handleMenuItemClicked(false);
    }}
    type="primary"
  >
    {EDIT_TRADE_DETAILS_LABELS.FINISH}
  </FinishButton>,
];